import DOMPurify from "dompurify";

export const sanitizeHtml = (htmlText: string): string => {
   return DOMPurify.sanitize(htmlText);
};
